module.exports = __webpack_public_path__ + "img/loading.4e15c843.gif";